import React from 'react';
import { Nullable } from 'global';
import { NO_DATA } from 'constants/common';
import { Stack, Tooltip, Typography } from '@mui/material';

interface Props {
  subject: Nullable<string>;
  description: Nullable<string>;
}

export const SubjectCell = ({ subject, description }: Props) => (
  <Stack gap="0.25rem">
    <Typography variant="body2" fontWeight={600} noWrap>
      {subject || NO_DATA}
    </Typography>

    {description && (
      <Tooltip title={description}>
        <Typography variant="caption" color="text.secondary" noWrap sx={{ maxWidth: '16rem' }}>
          {description}
        </Typography>
      </Tooltip>
    )}
  </Stack>
);
